// extracted by mini-css-extract-plugin
module.exports = {"info":"TalentExplainer_info__d62Oi","itemTitle":"TalentExplainer_itemTitle__en30U","itemLeft":"TalentExplainer_itemLeft__T_dqP","itemRight":"TalentExplainer_itemRight__xLENM"};